import { CreatedInterfaces } from '../interfaces';
import { useGetRequest } from './utils/useGetRequest';

const resource = 'csv-transactions';

const useGetCsvFile = (
  path: string
) => {

  const [{ data, error, loading: isLoading }, execute] = useGetRequest<CreatedInterfaces<typeof resource>>({
    path: path,
    manual: true,
  });

  return {
    fileUrl: data?.url,
    fileLoading: isLoading,
    isFileError: error,
    execute
  };
}

export default useGetCsvFile;